import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import * as Yup from "yup";
import {
  COMPANY_FETCH_URL, WORKER_DETAILED_REPORT_URL, WORKER_TYPES_URL,

} from "../../../configs/constants";
import Table from "components/Table";
import Filter from "@Components/Filter";
import { useNotifyContext } from "components/Notify";



let model = [
  { id: "worker_id", label: "Worker ID", type: "string" },
  { id: "name", label: "Name", type: "string" },
  { id: "company", label: "Company", type: "string" },
  { id: "zone", label: "Zone", type: "string" },
  { id: "region", label: "Region",type: "string" },
  { id: "estate", label: "Estate", type: "string" },
  { id: "date", label: "User Access Date", type: "date" },
  { id: "homepage", label: "Homepage", type: "string" },
  { id: "eworker", label: "eWorker", type: "string" },
  { id: "contract", label: "Contract", type: "string" },
  { id: "attendance", label: "Attendance", type: "string" },
  { id: "grievance", label: "Grievance", type: "time" },
  { id: "sos", label: "SOS", type: "time" },
  { id: "productivity", label: "Productivity", type: "string" },
  { id: "nationality", label: "Nationality", type: "string" },
  { id: "supervisor_name", label: "Supervisor Name", type: "string" },
  { id: "worker_group_name", label: "Worker Group Name", type: "string" },

  
];



const workerAccessDetailreport = () => {
  const [filterValues, setFilterValues] = useState({});
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [selectedFormDate, setSelectedFormDate] = useState(null);
  const [selectedtoDate, setSelectedToDate] = useState(null);
  const [detailLoading,setDetailLoading] = useState([]);
  const setNotify = useNotifyContext();


  const details = useLocation();
  const URLS = {
    WORKER_REPORT: "report/worker-module-access-detailed",
  };
  const today = new Date();
  today.setDate(today.getDate() - 1);
  const options = { timeZone: 'Asia/Kuala_Lumpur' };
  let date = today.toLocaleDateString('en-GB', options);
  date = date.split('/').reverse().join('-');
  
  const getFormDate = (e) => {
    setSelectedFormDate(e);
  };
  const getToDate = (e) => {
    setSelectedToDate(e);
  };
  const filterFields = [

    {
      type: "datepicker",
      label: "From User Access Date ",
      name: "from",
      maxDate: selectedtoDate,
      getValue: getFormDate,
      required: true

    },
    {
      type: "datepicker",
      label: "To User Access Date ",
      name: "to",
      minDate: selectedFormDate,
      getValue: getToDate,
      required: true

    },
    {
        type: "reactselect",
        name: "worker-type",
        label: "Worker Type",
        proxyUrl: WORKER_TYPES_URL,
        paginated: false,
        required: true,
      },
     

    
      {
        type: "reactselect",
        name: "company",
        label: "Company",
        proxyUrl: COMPANY_FETCH_URL,
        paginated: true,
        required: true,

        
  
      },
    
   
    
    
 
    
    
    
  ];
  
  

  const validationSchema = Yup.object({
    from: Yup.date().required("Date is required").nullable().typeError("Invalid From Last Login Date"),
    to: Yup.date().required("Date is required").nullable().typeError("Invalid To Last Login Date"),
    company: Yup.string().required("Company is required").nullable().typeError("Company is required"),
    "worker-type": Yup.string().required("Worker Type is required").nullable().typeError("Worker Type is required"),


  });
  const filterInitialValues = {
    from: date,
    to: date,

  };
  let filters = {};
  if ("searchParams" in details) {
    if (details.searchParams.from.dateForAPI) {
      filters["from"] = details.searchParams.from.dateForAPI;
    }
    if (details.searchParams.to.dateForAPI) {
      filters["to"] = details.searchParams.to.dateForAPI;
    }

  }
  const onFilterRequest = (values) => {
    const fromDate = new Date(values.from);
    const toDate = new Date(values.to);

    if (fromDate.getMonth() !== toDate.getMonth()) {
        setNotify({
            isOpen: true,
            message: "Date should be from the same month.",
            type: "error",
        });
        return;
    }

    const diffInDays = Math.floor((toDate.getTime() - fromDate.getTime()) / (1000 * 60 * 60 * 24)) + 1;


    setFiltersApplied(true);

    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
        if (value !== null && value !== "") {
            filterObj[key] = value;
        }
    }
    setDetailLoading (false);
    setFilterValues(filterObj);
};
const clearFilter =()=>{
  filterInitialValues.status = null
  location.reload();
 }
 
return (
  <>
    <Filter
      filterFields={filterFields}
      initialValues={filterInitialValues}
      onSubmit={onFilterRequest}
      validationSchema={validationSchema}
      onClear={clearFilter}



    />
    <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
          

          

      </div>

      {filtersApplied ? (

<Table
proxyURL={WORKER_DETAILED_REPORT_URL}
model={model}
filterValues={filterValues}
noFilter
noAddButton
excelExport={{ fileName: "WorkerReport" }}
pdfExport={{ fileName: "WorkerReport" }}
paginationDisable = {true}
tableBodyDisable = {true}
loading={detailLoading}
setLoading={setDetailLoading}
/>
) : (

  <Table
  proxyURL={null}
  model={model}
  exportUrl="url"
  filterValues={filterValues}
  noFilter
  paginationDisable = {true}
  tableBodyDisable = {true}
  excelExport={{ fileName: "WorkerReport" }}
  pdfExport={{ fileName: "WorkerReport" }}
  noAddButton
  loading={detailLoading}
  setLoading={setDetailLoading}
/>
)}
   

  </>
);


};
export default workerAccessDetailreport;

